export enum EFeedback {
  LIKE = 'CORRECT',
  DISLIKE = 'INCORRECT',
}
